const racesWithBetsPlacedInThisSession = new Set<string>()

export function hasBetForRaceKey(raceKey: string) {
  return racesWithBetsPlacedInThisSession.has(raceKey)
}

export function addBetForRaceKey(raceKey: string) {
  racesWithBetsPlacedInThisSession.add(raceKey)
}
